/* eslint-disable react/jsx-filename-extension */
import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import Estate from 'accessa/lib/Footers/Estate'
import { Box, Link as MuiLink } from '@material-ui/core'
import { get } from 'lodash'
import { useTranslation } from 'react-i18next'
import { getLocale } from '../utils/i18n-helpers'

const makeCopyRightStatement = () =>
  `© ${new Date().getFullYear()} - Canada Rubber Group`

const Footer = () => {
  const {
    contentfulContact: {
      email,
      streetLine,
      city,
      postalCode,
      tollFreePhoneNumber,
      social,
      graphic,
    },
    allContentfulNavigation: { nodes },
  } = useStaticQuery(graphql`
    {
      contentfulContact {
        email
        streetLine
        city
        postalCode
        tollFreePhoneNumber
        social
        graphic {
          alt: title
          file {
            url
          }
        }
      }
      allContentfulNavigation(
        filter: {
          contentful_id: { eq: "77FEHqU1r3twQbrvjme98z" }
        }
      ) {
        nodes {
          node_locale
          pages {
            ... on ContentfulPage {
              title
              relativePath
            }
            ... on ContentfulArchive {
              title
              relativePath
            }
          }
        }
      }
    }
  `)

  const { t } = useTranslation('labels')
  const pages =
    nodes.find((n) => n.node_locale.startsWith(getLocale()))
      ?.pages || []

  return (
    <Box pt={8} bgcolor="background.default">
      <Estate
        logo={{
          fluid: { src: get(graphic, 'file.url') },
          alt: get(graphic, 'alt', 'CRG'),
          style: {
            height: 50,
            width: 250,
          },
          imgStyle: {
            objectFit: 'contain',
          },
        }}
        properties={[
          {
            subtitle: t('contactInformation'),
            body1: (
              <MuiLink href={`mailTo:${email}`}>
                {email}
              </MuiLink>
            ),
            body2: (
              <MuiLink href={`tel:${tollFreePhoneNumber}`}>
                {tollFreePhoneNumber}
              </MuiLink>
            ),
          },
          {
            subtitle: t('location'),
            body1: streetLine,
            body2: [city, postalCode]
              .filter(Boolean)
              .map((item) => String(item).trim())
              .join(', '),
          },
        ]}
        socials={social}
        company={makeCopyRightStatement()}
        text={pages
          .map(({ title, relativePath = '/' }) => (
            <MuiLink
              to={relativePath}
              style={{ margin: '0 1rem' }}
              component={Link}
              color="inherit"
              key={relativePath}
              getProps={({ isCurrent }) => {
                if (isCurrent)
                  return {
                    style: {
                      textDecoration: 'underline',
                    },
                  }

                return {}
              }}
            >
              {title}
            </MuiLink>
          ))
          .concat(
            <MuiLink
              style={{ margin: '0 1rem' }}
              color="inherit"
              href="https://assets.ctfassets.net/ia2wp84ph7dg/41LjoU6PUJnjkfy9wpX86h/b3f19f68ef493eab828fab4e88462092/Accessibility_Policy_and_Multi-Year_Accessibility_Plan.pdf"
              target="_blank"
            >
              {getLocale() === 'en'
                ? 'Accessibility Plan'
                : "Plan d'accessibilité"}
            </MuiLink>
          )}
      />
    </Box>
  )
}

export default Footer
